import { useQuery } from '@tanstack/react-query'
import { CalendarOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ApiError } from '@/api/errors'
import { EmptyState, ErrorState, LoadingState } from '@/components/feedback/States'
import { PageHeader } from '@/components/ui/PageHeader'
import { staffLeaveScope } from '@/features/leave/api'
import { LeaveSelfService } from '@/features/leave/components/LeaveSelfService'
import { staffPortalQuery } from '@/features/portal/api'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

/** Staff portal → My leave. */
export function MyLeavePage() {
  const { t } = useTranslation('leave')
  useDocumentTitle('My leave')
  const me = useQuery(staffPortalQuery())

  return (
    <>
      <PageHeader
        title={t('My leave')}
        description={
          me.data?.academicYear
            ? t('Balances and requests for {{year}}.', { year: me.data.academicYear.name })
            : t('Your balances and leave requests.')
        }
        breadcrumbs={[{ label: t('My workspace'), to: '/staff' }, { label: t('My leave') }]}
        homeHref="/staff"
      />
      {me.isPending ? (
        <LoadingState />
      ) : me.error ? (
        me.error instanceof ApiError && me.error.status === 404 ? (
          <EmptyState
            icon={<CalendarOff />}
            title={t("Your account isn't linked yet")}
            description={me.error.message}
          />
        ) : (
          <ErrorState onRetry={() => void me.refetch()} />
        )
      ) : (
        <LeaveSelfService scope={staffLeaveScope} subject={t('yourself')} />
      )}
    </>
  )
}
